<template>
	<div class="vipmapping">
		<Nav></Nav>
		<HomeNav currentTab="2"></HomeNav>
		<div class="diy-service-wrap">
			<div class="diy-service">
				<div class="back" @click="goBack">
					<div class="back-icon"></div>
					创建自定义服务
				</div>
				<div class="diy-title">创建自定义服务</div>
				<div class="diy-item">
					<div class="diy-text">选择内网</div>
					<div class="device-list-wrap">
						<div
							:class="{
								'select-icon': true,
								'select-icon2': isShowDeviceList,
							}"
							@click="switchClick"
						></div>
						<div class="device-list" v-if="isShowDeviceList">
							<div
								class="device-item"
								v-for="(item, index) in list"
								:key="index"
								@click="itemClick(item, index)"
							>
								{{
									item.term.comment
										? item.term.comment
										: item.term.name
										? item.term.name
										: item.peerid
								}}
							</div>
						</div>
						<div
							class="item-text"
							v-if="JSON.stringify(item) != '{}'"
						>
							{{
								item.term.comment
									? item.term.comment
									: item.term.name
									? item.term.name
									: item.peerid
							}}
						</div>
						<div
							class="item-text"
							v-if="
								!isShowDeviceList &&
								JSON.stringify(item) == '{}'
							"
						>
							在所选设备的局域网中创建服务
						</div>
					</div>
				</div>
				<div class="diy-item">
					<div class="diy-text">服务名称</div>
					<div class="diy-input-wrap">
						<input
							placeholder="请输入服务名称"
							type="text"
							v-model="name"
						/>
					</div>
				</div>
				<div class="diy-item">
					<div class="diy-text">服务IP</div>
					<div class="diy-input-wrap">
						<input
							placeholder="请输入内网IP"
							type="text"
							v-model="ip"
						/>
					</div>
				</div>
				<div class="diy-item">
					<div class="diy-text">服务端口</div>
					<div class="diy-input-wrap diy-input-wrap2">
						<input
							placeholder="请输入端口"
							type="number"
							v-model="port"
						/>
					</div>
				</div>
				<div class="btn" @click="addClick">创建</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions } from "vuex";
import Nav from "@/components/Common/Nav.vue";
import HomeNav from "@/components/Common/HomeNav.vue";
export default {
	components: {
		Nav,
		HomeNav,
	},
	data: function () {
		return {
			list: [],
			isShowDeviceList: false,
			item: {},
			name: "",
			ip: "",
			port: "",
		};
	},
	methods: {
		...mapActions(["bindget", "nodelistmanset"]),
		goBack: function () {
			this.$router.back(-1);
		},
		addClick: function () {
			let _that = this;
			if (JSON.stringify(_that.item) == "{}") {
				_that.$store.state.toast = "请选择设备内网";
				return;
			}

			if (!_that.name) {
				_that.$store.state.toast = "请输入服务名称";
				return;
			}

			if (!_that.ip) {
				_that.$store.state.toast = "请输入服务IP";
				return;
			}
			if (!_that.$common.isValidIP(_that.ip)) {
				_that.$store.state.toast = "请输入正确的服务IP地址";
				return;
			}

			if (!_that.port) {
				_that.$store.state.toast = "请输入服务端口";
				return;
			}
			_that.port = parseInt(_that.port);

			if (_that.port < 1 || _that.port > 65536) {
				_that.$toast("请输入正确的端口：1~65536");
				return;
			}

			let addArr = [];
			addArr.push({
				host: _that.ip,
				port: _that.port,
				name: _that.name,
				dtype: 999,
			});
			_that.nodelistmanset([
				_that.item.peerid,
				addArr,
				function (err, data) {
					if (!err && !data.rtn) {
						_that.$store.state.toast = "添加成功";
						_that.goBack();
					} else {
						_that.$toast("添加失败:" + data.rtn);
					}
				},
			]);
		},
		itemClick: function (data) {
			let _that = this;
			_that.item = data;
			_that.isShowDeviceList = false;
		},
		switchClick: function () {
			let _that = this;
			_that.isShowDeviceList = !_that.isShowDeviceList;
		},
		getBindget: function () {
			let _that = this;
			//用户是否有绑定设备
			_that.bindget([
				function (err, data) {
					if (data && !data.rtn) {
						//rtn等于0时，后台不返回此字段
						if (data && data.terms && data.terms.length > 0) {
							_that.list = data.terms;

							for (
								let index = 0;
								index < _that.list.length;
								index++
							) {
								const element = _that.list[index];
								let pidInfo = _that.$common.getInfoByPid(
									element.peerid
								);

								// 构造ip mac 信息
								element.ip = "";
								element.mac = "";

								if (element.term && !element.term.name) {
									element.term.name =
										pidInfo.cname + pidInfo.dname;
								}

								if (element.term && element.term.nic) {
									let nic = _that.$common.getNicByNics(
										element.term.nic
									);
									if (nic) {
										element.ip = nic.ipv4n;
										element.mac = nic.mac;
									}
								}
								if (element.term && element.term.comment) {
									if (element.term.comment == "0") {
										element.term.comment = "";
									}
								}
							}
						}
					}
				},
			]);
		},
	},
	activated: function () {
		let _that = this;
		_that.getBindget();
		_that.name = "";
		_that.ip = "";
		_that.port = "";
	},
};
</script>
<style lang="less" scoped>
.diy-service-wrap {
	background-color: #f2f5fa;
	width: 960px;
	height: 426px;
	overflow: hidden;
}
.diy-service {
	margin: 0 auto;
	width: 940px;
	height: 418px;
	box-sizing: border-box;
	border-radius: 4px;
	// background-image: url("../assets/vip/bg.png");
	background-repeat: no-repeat;
	background-size: 100% 100%;
	background-color: #ffffff;
	border: 1px solid #e8c29b;
	border-top: none;
	border-top-left-radius: 0;
	border-top-right-radius: 0;
	overflow: hidden;
	.back {
		width: 200px;
		line-height: 50px;
		font-size: 14px;
		color: #666666;
		cursor: pointer;
		.back-icon {
			display: inline-block;
			margin-top: 16px;
			margin-left: 24px;
			margin-right: 6px;
			vertical-align: top;
			width: 16px;
			height: 16px;
			background-image: url("../assets/vip/back.svg");
			background-repeat: no-repeat;
			background-size: 100% 100%;
		}
	}
	.diy-title {
		margin-top: 5px;
		font-weight: 700;
		font-size: 24px;
		line-height: 24px;
		color: #1a1a1a;
		text-align: center;
	}
	.diy-item {
		margin-top: 20px;
		.device-list-wrap {
			position: relative;
			display: inline-block;
			vertical-align: top;
			line-height: 42px;
			width: 264px;
			height: 42px;
			background-color: #fcfdff;
			border: 1px solid #cbcdd1;
			border-radius: 48px;
			box-sizing: border-box;
			.select-icon {
				position: absolute;
				top: -1px;
				right: 20px;
				width: 24px;
				height: 42px;
				background-image: url("../assets/vip/open.svg");
				background-repeat: no-repeat;
				background-size: 13px 7px;
				background-position: center;
				cursor: pointer;
			}
			.select-icon2 {
				transform: rotate(180deg);
				transition: transform 0.3s ease-in-out;
			}
			.device-list {
				position: absolute;
				z-index: 1;
				top: 46px;
				right: -1px;
				width: 264px;
				height: 158px;
				background-color: #ffffff;
				box-shadow: 0px 0px 6px rgba(73, 80, 90, 0.2);
				border-radius: 8px;
				overflow-y: scroll;
				.device-item {
					position: relative;
					padding-left: 24px;
					height: 42px;
					width: 100%;
					box-sizing: border-box;
					color: #999999;
					cursor: pointer;
				}
				.device-item::after {
					position: absolute;
					bottom: 0;
					left: 50%;
					transform: translate(-50%, 0);
					content: "";
					width: 216px;
					height: 1px;
					background-color: #cbcdd1;
				}

				.device-item:hover {
					background-color: #eef0f5;
					color: #2b3f7f;
				}
			}
			.item-text {
				margin-left: 20px;
				font-size: 14px;
				color: #999999;
			}
		}
		.diy-text,
		.diy-input-wrap {
			display: inline-block;
			vertical-align: top;
			line-height: 42px;
		}
		.diy-text {
			margin-left: 250px;
			width: 112px;
			color: #666666;
			font-size: 16px;
		}
		.diy-input-wrap {
			position: relative;
			width: 264px;
			height: 42px;
			background-color: #fcfdff;
			border: 1px solid #cbcdd1;
			border-radius: 48px;
			box-sizing: border-box;
			overflow: hidden;
			input {
				padding-left: 24px;
				width: 100%;
				height: 100%;
				background-color: transparent;
				color: #666666;
				font-size: 15px;
			}
		}
		.diy-input-wrap2 {
			width: 136px;
		}
	}
	.btn {
		margin: 0 auto;
		margin-top: 20px;
		width: 186px;
		height: 48px;
		line-height: 48px;
		background: linear-gradient(156deg, #2f4386 27%, #1b3065 82%);
		box-shadow: 0px 4px 8px rgba(43, 48, 57, 0.2);
		border-radius: 120px;
		font-weight: 700;
		font-size: 18px;
		text-align: center;
		color: #ffffff;
		cursor: pointer;
	}
	.btn:hover {
		opacity: 0.9;
		cursor: pointer;
	}
}
</style>